import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { firstValueFrom, Observable } from "rxjs";

import { environment } from "@env/environment";
import { UrlBuilder } from "@app/shared/helpers";
import { PaginatedResult } from "@app/shared/models";
import { NoticeResponse } from "@app/shared/models/notices/notice-response.model";
import { NoticeCreate } from "@app/shared/models/notices/notice-create.model";
import { NoticeUpdate } from "@app/shared/models/notices/notice-update.model";
import { IgnoreNoticeBoardFlagModel } from "@app/shared/models/notices/ignore-notice-board-flag.model";


@Injectable({
  providedIn: 'root'
})
export class NoticeService {
  private readonly http = inject(HttpClient);

  public getPaginatedNotices(page: number, pageSize: number): Promise<PaginatedResult<NoticeResponse>> {
    const urlBuilder: UrlBuilder = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('v1', 'admin', 'notice')
      .addQueryParam('page', page.toString())
      .addQueryParam('pageSize', pageSize.toString())      

    return firstValueFrom(this.http.get<PaginatedResult<NoticeResponse>>(urlBuilder.build()));
  }

  public getNoticeById(id: number): Observable<NoticeResponse> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('v1', 'admin', 'notice', id.toString())
      .build();
    return this.http.get<NoticeResponse>(url);
  }


  public deleteNoticeById(id: number): Observable<unknown> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('v1', 'admin', 'notice', id.toString())
      .build();
    return this.http.delete(url);
  }

  public createNotice(createNotice: NoticeCreate): Observable<NoticeResponse> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('v1', 'admin', 'notice')
      .build();
    return this.http.post<NoticeResponse>(url, createNotice);
  }

  public updateNoticeById(id: number, noticeUpdate: NoticeUpdate): Observable<NoticeResponse> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('v1', 'admin', 'notice', id.toString())
      .build();
    return this.http.put<NoticeResponse>(url, noticeUpdate);
  }

  public getNoticesToShow(): Promise<NoticeResponse[]> {
    const urlBuilder: UrlBuilder = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('notice')
      
    return firstValueFrom(this.http.get<NoticeResponse[]>(urlBuilder.build()));
  }

  public getIgnoreNoticeBoardFlag(): Promise<IgnoreNoticeBoardFlagModel> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('notice', 'ignore-notice-board-flag')
      .build();
    return firstValueFrom(this.http.get<IgnoreNoticeBoardFlagModel>(url));
  }

  public updateIgnoreNoticeBoardFlag(ignoreNoticeBoardFlagModel: IgnoreNoticeBoardFlagModel): Promise<IgnoreNoticeBoardFlagModel> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('notice', 'ignore-notice-board-flag')
      .build();
    return firstValueFrom(this.http.put<IgnoreNoticeBoardFlagModel>(url, ignoreNoticeBoardFlagModel));
  }
}
